import React from "react";

interface ExperienceBarProps {
  experience: number;
}

const ExperienceBar: React.FC<ExperienceBarProps> = ({ experience }) => {
  const level = Math.floor(experience / 500);
  const expForCurrentLevel = experience % 500;
  const expPercentage = (expForCurrentLevel / 500) * 100;

  return (
    <div className="flex flex-col items-center dark:text-slate-200 text-slate-800">
      <div className="text-lg font-bold mb-2">레벨 {level}</div>
      <div className="w-full bg-gray-200 dark:bg-slate-500 rounded-full h-6 shadow-lg">
        <div
          className="bg-gradient-to-r from-pink-300 to-pink-600 h-6 rounded-full transition-all duration-700 shadow-xl"
          style={{ width: `${expPercentage}%` }}
        ></div>
      </div>
      <div className="text-sm mt-3">{expForCurrentLevel} / 500 경험치</div>
    </div>
  );
};

export default ExperienceBar;
